import * as API from './API'

export default {
    //회원 자산정보 조회
    async getAssetInfo(userType2) {
        let parameters = {
            method: 'GET',
            path: '/api/assets/user/briefing',
            params: {userType2: userType2}
        }
        const apiResponse = await API.request(parameters)
        return apiResponse
    },

    //회원 출금 내역 조회
    async getAssetHistory(currentPage, rowsPerPage) {
        let parameters = {
            method: 'GET',
            path: '/api/assets/withdrawal-request',
            params: {
                page: currentPage,
                size: rowsPerPage,
            }
        }
        const apiResponse = await API.request(parameters)
        return apiResponse
    },

    async getNoWithrawalList() {
        let parameters = {
            method: 'GET',
            path: '/api/assets/log/no-withdrawal-request',
            params: {}
        }
        const apiResponse = await API.request(parameters)
        return apiResponse
    },

    async requestWithdraw(args) {
        let parameters = {
            method: 'POST',
            path: '/api/assets/withdrawal-request',
            data: args.formData,
            params: {}
        }
        const apiResponse = await API.formDataRequest(parameters)
        return apiResponse
    }
}



// WEBPACK FOOTER //
// ./src/service/assetAPI.js